export default {
  manual: 'Handmatig',
  filters: {
    status: 'Status',
    event_type: 'Gebeurtenistype',
  },
  columns: {
    event: 'Gebeurtenis',
    status: 'Status',
    attempts: 'Pogingen',
    last_http_status: 'Laatste HTTP-status',
    created_at: 'Aangemaakt',
  },
  statuses: {
    pending: 'In behandeling',
    delivered: 'Afgeleverd',
    failed: 'Mislukt',
  },
  buttons: {
    details: 'Details',
    resend: 'Opnieuw verzenden',
  },
  detail: {
    title: 'Leveringsdetails',
    event: 'Gebeurtenis',
    attempts: 'Pogingen',
    no_attempts: 'Nog geen pogingen.',
    no_response: 'geen reactie',
    payload: 'Payload',
  },
  toasts: {
    load_error: 'Kan de leveringen niet laden.',
    resend_error: 'Kan de levering niet opnieuw verzenden.',
    resent: 'Levering in wachtrij voor opnieuw verzenden.',
  },
};
